module.exports = __webpack_public_path__ + "img/twitter-source.abfbd4d9.svg";